export const ABORT_ERROR_MESSAGE = "AbortError";
export const CHAT_TOP_MENU_ACTIONS = {
    START_NEW_CHAT: "start_new_chat",
    VIEW_SAVED_CHAT: "view_saved_chat",
    EDIT_AUTORESPONSE_MODE: "edit_autoresponse_mode",
    REMOVE_MESSAGES: "remove_messages",
    CHANGE_PERSONA: "change_persona",
    CLONE_CONVERSATION: "clone_conversation",
    CHANGE_TITLE: "change_title",
    CHANGE_VOICE: "change_voice",
    UNLOCK_CUSTOM_VOICES: "unlock_custom_voices",
    LIKE_UNLIKE_BOT: "like__unlike_bot",
    VIEW_BOT_PROFILE: "view_bot_profile",
    EDIT_CHATBOT: "edit_chatbot",
    EDIT_GROUP: "edit_group",
    BLOCK_CREATOR: "block_creator",
    MANAGE_MEMORIES: "manage_memories",
    TOGGLE_AUTO_MEMORY: "toggle_auto_memory",
    GENERATION_SETTINGS: "generation_settings",
    SWITCH_STORYMODE: "switch_storymode",
    SWITCH_CHATMODE: "switch_chatmode",
};
export const CHAT_INPUT_ACTIONS = {
    SEND: "Send",
    TOGGLE_RECORDING: "toggle_recording",
    GENERATE_IMAGE: "generate_image",
    AUTO_PILOT: "auto_pilot",
    CANCEL_EDIT: "CancelEdit",
    SAVE_EDIT: "SaveEdit",
};
